// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"2237fa8b","362":"3c6a14b7","453":"dd3bdf49","585":"36f59d02","862":"66b82eb4","868":"4daf50b8","890":"8bc0f35d"}[chunkId] + ".chunk.js";
};